import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedBrandAction, updateBrandAction } from '../../../redux/actions/brandsActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import BrandForm from '../forms/BrandForm';

const UpdateBrandModal = ({ readOnly, onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const brand = useSelector((state) => state.brands?.brand);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(updateBrandAction(data));
    await dispatch(clearSelectedBrandAction());
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Змінити марку'}
      loading={loading}
      onClose={onModalClose}
      body={<BrandForm readOnly={readOnly} onSubmit={onSubmit} loading={loading} initBrand={brand} />}
      actionButton={
        !readOnly && (
          <Button type={'submit'} disabled={loading} variant={'primary'} formId={'brand-form'} children={'Змінити'} />
        )
      }
    />
  );
};

export default UpdateBrandModal;
